// TEMP! used for calling it from old code

import { renderModalDialog } from 'reactApp/utils/createDialogToolkit';

import { LicenseAgreement } from './LicenseAgreement';

export const renderLicenseAgreementDialog = renderModalDialog(LicenseAgreement, 'LicenseAgreement');
